/**
 * Created by sswaminathan on 2/4/22
 * File: ValidationFetcher.js
 * Project: MSP ©Palo Alto Networks
 * © Palo Alto Networks
 */

// import statement lib, local then scss or css

import { APP_ID_PRISMA_SAAS } from '../../../common/constants/GlobalConstants'

/**
 *   TODO: Brief what is this component/class do
 */

const ValidationFetcher = (app_id, license_type, rest) => {
  const { licenseValue, validation } = rest
  const appValidation = validation ? validation[licenseValue] ? validation[licenseValue][app_id] : [] : []
  if (app_id === APP_ID_PRISMA_SAAS) {
    return {
      app_id,
      validation_required: true
    }
  }
  const response = appValidation && appValidation.length ? appValidation.filter((each) => {
    return each.app_id === app_id && each.license_type === license_type
  }) : []
  return response.length > 0 ? response[0] : {}
}

export default ValidationFetcher
